"use strict";
/* istanbul ignore file: dev tooling */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportAccessibility = void 0;
const web_env_1 = require("@snapchat/web-env");
/**
 * Report accessibility issues locally using AXE https://www.deque.com/axe/
 * @param app React App instance
 * @param timeout [Optional] Debounce timeout in milliseconds
 * @param config AxeCore Config
 */
const reportAccessibility = async (app, timeout = 1000, config) => {
    if (typeof (0, web_env_1.getWindow)() !== "undefined" && process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const axe = await Promise.resolve().then(() => __importStar(require("@axe-core/react")));
        const ReactDOM = await Promise.resolve().then(() => __importStar(require("react-dom")));
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        await axe.default(app, ReactDOM, timeout, config);
    }
};
exports.reportAccessibility = reportAccessibility;
//# sourceMappingURL=reportAccessibility.js.map